import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type DayPass = {
  error?: Maybe<Scalars['String']>;
  info?: Maybe<DaypassInfo>;
  successful: Scalars['Boolean'];
};

export type DaypassInfo = {
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['Float'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  vrm: Scalars['String'];
};

export type DaypassInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  vrm: Scalars['String'];
};

export type Mutation = {
  createDayPass: DayPass;
};


export type MutationCreateDayPassArgs = {
  input: DaypassInput;
};

export type Query = {
  sayHello: Scalars['String'];
};

export type CreateDayPassMutationVariables = Exact<{
  vrm: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  tenantId: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
}>;


export type CreateDayPassMutation = { createDayPass: { successful: boolean, error?: string | null, info?: { id: number, vrm: string, firstName: string, lastName: string, tenantId: string, email?: string | null, phone?: string | null } | null } };


export const CreateDayPassDocument = gql`
    mutation CreateDayPass($vrm: String!, $firstName: String!, $lastName: String!, $tenantId: String!, $email: String, $phone: String) {
  createDayPass(
    input: {vrm: $vrm, firstName: $firstName, lastName: $lastName, tenantId: $tenantId, email: $email, phone: $phone}
  ) {
    info {
      id
      vrm
      firstName
      lastName
      tenantId
      email
      phone
    }
    successful
    error
  }
}
    `;
export type CreateDayPassMutationFn = Apollo.MutationFunction<CreateDayPassMutation, CreateDayPassMutationVariables>;

/**
 * __useCreateDayPassMutation__
 *
 * To run a mutation, you first call `useCreateDayPassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDayPassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDayPassMutation, { data, loading, error }] = useCreateDayPassMutation({
 *   variables: {
 *      vrm: // value for 'vrm'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      tenantId: // value for 'tenantId'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useCreateDayPassMutation(baseOptions?: Apollo.MutationHookOptions<CreateDayPassMutation, CreateDayPassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDayPassMutation, CreateDayPassMutationVariables>(CreateDayPassDocument, options);
      }
export type CreateDayPassMutationHookResult = ReturnType<typeof useCreateDayPassMutation>;
export type CreateDayPassMutationResult = Apollo.MutationResult<CreateDayPassMutation>;
export type CreateDayPassMutationOptions = Apollo.BaseMutationOptions<CreateDayPassMutation, CreateDayPassMutationVariables>;